import { render, staticRenderFns } from "./RC_motivation.vue?vue&type=template&id=1841c387&scoped=true"
import script from "./RC_motivation.vue?vue&type=script&lang=js"
export * from "./RC_motivation.vue?vue&type=script&lang=js"
import style0 from "./RC_motivation.vue?vue&type=style&index=0&id=1841c387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841c387",
  null
  
)

export default component.exports